import React, { useState, useEffect } from 'react';

import TextField from '../../TextField/TextField';

export const ValueEditorText = ({ value, style, disabled, autoFocus, onChange }) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => setInternalValue(value), [value]);

  const handleChange = (event) => {
    setInternalValue(event.target.value);

    onChange(event.target.value);
  };

  return <TextField value={internalValue} style={style} onChange={handleChange} disabled={disabled} autoFocus={autoFocus} />;
};
